"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeruPlanCardParser = void 0;
var _services = require("../../../services");
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _useQuestionsMetadata = require("../../../hooks/questionnaire/useQuestionsMetadata");
var _PlanCardParser = require("../generic/PlanCardParser");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class PeruPlanCardParser extends _PlanCardParser.PlanCardParser {
  constructor(props) {
    super(props);
  }
  get EntelCardHeaderProps() {
    return !this.isAdditionalPlan ? this.EntelCardHeaderPropsWithData : this.EntelCardHeaderPropsWithDefault;
  }
  get EntelCardHeaderPropsWithData() {
    // This section needs to be removed, DO NOT USE HOOKS outside of React components and custom hooks
    const showFullPlanName = (0, _useConfig.default)('showFullPlanName', true);
    const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)();
    // -------------------------------------------------------------------------------------------------
    const planPortLine = metadata.flags.planPortLine;
    const mainPriceBeforeDiscount = Object.keys(this.getPriceByPriceType('recurring-total1')).length > 1 ? this.getPriceByPriceType('recurring-total1') : this.getPriceByPriceType('recurring');
    const mainPriceAfterDiscount = this.getPriceByPriceType('commerce');
    const rightStackMainTextLarge = `${_services.locale.formatPrice(mainPriceAfterDiscount.priceValue)}`;
    const rightStackMainTextNormal = `/${_services.locale.localeString('Recommendation.month')}`;
    const rightStackBottomTextNormal = mainPriceBeforeDiscount.priceValue ? _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: mainPriceAfterDiscount.durationAmount,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(mainPriceBeforeDiscount.priceValue),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    }) : '';
    const amount = Math.round(100 * (1 - mainPriceAfterDiscount.priceValue / mainPriceBeforeDiscount.priceValue));
    const showDiscount = planPortLine && amount > this.minimumDiscount;
    const topHeader = _services.locale.localeString('Recommendation.OtherPlanName');
    const productName = showFullPlanName ? this.plan.productName : this.plan.productName.split('Plan')[1];
    return {
      leftStack: {
        topText: topHeader,
        mainText: productName,
        planIndex: this === null || this === void 0 ? void 0 : this.planIndex
      },
      rightStack: {
        pillText: !!amount && showDiscount && _services.locale.localeString('Recommendation.DiscountText', {
          amount: amount
        }),
        show5g: true,
        showSecondPrice: true,
        mainText: {
          large: showDiscount ? rightStackMainTextLarge : _services.locale.formatPrice(mainPriceBeforeDiscount.priceValue),
          normal: rightStackMainTextNormal
        },
        showBottomText: mainPriceAfterDiscount.priceValue !== mainPriceBeforeDiscount.priceValue,
        bottomText: showDiscount ? rightStackBottomTextNormal : ''
      }
    };
  }
  get EntelCardHeaderPropsWithDefault() {
    const priceBeforeDiscount = this.getPriceByPriceType('commerceAdditionalPlanPrice');
    const priceAfterDiscount = this.getPriceByPriceType('listAdditionalPlanPrice');
    const rightStackMainTextLarge = `${_services.locale.formatPrice(priceAfterDiscount.priceValue * this.numPlans)}`;
    const rightStackMainTextNormal = `/${_services.locale.localeString('Recommendation.month')}`;
    const rightStackMainTextPrefix = `${_services.locale.localeString('Recommendation.defaultPlanPrefix')} `;
    const rightStackBottomTextNormal = _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: priceBeforeDiscount.durationAmount,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(priceBeforeDiscount.priceValue * this.numPlans),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    });
    const amount = Math.round(100 * (1 - priceAfterDiscount.priceValue / priceBeforeDiscount.priceValue));
    const moreThanOnePlan = this.numPlans > 1;
    return {
      leftStack: {
        topText: '',
        mainText: _services.locale.localeString('Recommendation.DefaultPlan.AdditionalPlans', {
          amount: this.numPlans
        })
      },
      rightStack: {
        pillText: !!amount && _services.locale.localeString('Recommendation.DiscountText', {
          amount: amount
        }),
        show5g: true,
        showSecondPrice: moreThanOnePlan,
        mainText: {
          large: rightStackMainTextPrefix + rightStackMainTextLarge,
          normal: rightStackMainTextNormal
        },
        showBottomText: priceAfterDiscount.priceValue !== priceBeforeDiscount.priceValue,
        bottomText: rightStackBottomTextNormal,
        blueText: `${_services.locale.formatPrice(priceAfterDiscount.priceValue)}` + 'c/' + _services.locale.localeString('Recommendation.plan')
      }
    };
  }
  get EntelCardBodyProps() {
    return !this.isAdditionalPlan ? this.EntelCardBodyPropsWithData : this.EntelCardBodyPropsWithDefault;
  }
  get EntelCardBodyPropsWithData() {
    const characteristics = this.plan.selectedVariant.characteristics.filter(characteristic => {
      return this.recommendationCharacteristics.find(recommendationCharacteristic => recommendationCharacteristic.key === characteristic.name && (characteristic === null || characteristic === void 0 ? void 0 : characteristic.title) && characteristic.valueText);
    }).sort((ch1, ch2) => {
      return this.recommendationCharacteristics.findIndex(recommendationCharacteristic => recommendationCharacteristic.key === ch1.name) - this.recommendationCharacteristics.findIndex(recommendationCharacteristic => recommendationCharacteristic.key === ch2.name);
    }).map(characteristic => {
      var _this$recommendationC, _this$recommendationC2, _this$recommendationC3, _this$recommendationC4;
      const icon = (_this$recommendationC = this.recommendationCharacteristics) === null || _this$recommendationC === void 0 ? void 0 : (_this$recommendationC2 = _this$recommendationC.find(recommendationCharacteristic => {
        return recommendationCharacteristic.key == characteristic.name;
      })) === null || _this$recommendationC2 === void 0 ? void 0 : _this$recommendationC2.icon;
      return {
        src: {
          sm: icon,
          md: icon,
          lg: icon
        },
        icon: (_this$recommendationC3 = this.recommendationCharacteristics) === null || _this$recommendationC3 === void 0 ? void 0 : (_this$recommendationC4 = _this$recommendationC3.find(recommendationCharacteristic => {
          return recommendationCharacteristic.key == characteristic.name;
        })) === null || _this$recommendationC4 === void 0 ? void 0 : _this$recommendationC4.icon,
        text: this.getCharacteristicTitle(characteristic),
        description: characteristic.description
      };
    });
    return {
      characteristics,
      planIndex: this === null || this === void 0 ? void 0 : this.planIndex
    };
  }
  get EntelCardBodyPropsWithDefault() {
    const characteristics = this.recommendationCharacteristics.filter(characteristic => characteristic.title).map(characteristic => {
      return {
        src: {
          sm: characteristic.icon,
          md: characteristic.icon,
          lg: characteristic.icon
        },
        icon: characteristic.icon,
        text: this.getCharacteristicTitle({
          name: characteristic.key,
          title: characteristic.title,
          id: characteristic.key
        }),
        description: characteristic.description
      };
    });
    return {
      characteristics
    };
  }
}
exports.PeruPlanCardParser = PeruPlanCardParser;